<cam-layout-side class="full-width">
  <cam-layout-side-content>
    <cam-loader [isLoading]="this.parentRequestState().isLoading()">
      <cam-error
        [message]="this.parentRequestState().getErrorMessage()"
        [code]="this.parentRequestState().getErrorStatus()"
      >
        <ng-content></ng-content>
      </cam-error>
    </cam-loader>
  </cam-layout-side-content>
  <cam-layout-side-cta>
    <cam-loader [isLoading]="this.parentRequestState().isLoading()">
      <div class="justify-end">
        <cam-button
          (action)="this.askValidation$().next(null)"
          [state]="this.formValidity()() ? 'classic' : 'disabled'"
        >
          <div class="align-center m-space-xs">
            <cam-font-icon name="check-line" type="lg"></cam-font-icon>
            {{ 'core.validate' | translate }}
          </div>
        </cam-button>
      </div>
    </cam-loader>
  </cam-layout-side-cta>
</cam-layout-side>
